import {createFeatureSelector, createSelector} from "@ngrx/store";
import {addressesFeatureKey, AddressesState} from "./addresses.reducer";
import {SelectorUtil} from "@app-web-central/web/shared/utils";

export const getAddressesState = createFeatureSelector<AddressesState>(addressesFeatureKey);

export const getAddresses = createSelector(getAddressesState, (state) => state.data);
export const getAddressesLoading = createSelector(getAddressesState, SelectorUtil.isLoading);
